import styled from 'styled-components';
export var ImageWrapper = styled.div.withConfig({
    displayName: "imagestyled__ImageWrapper",
    componentId: "sc-8yt7hc-0"
})(["width:100%;border:1px solid var(--gray);"]);
export var StyledImage = styled.img.withConfig({
    displayName: "imagestyled__StyledImage",
    componentId: "sc-8yt7hc-1"
})(["width:100%;height:100%;"]);
